import { fromJS } from 'immutable';
import { WEBFORM_GET_LOADED, WEBFORM_GET_INFO_LOADED } from '../../../actions/Entity/Webform';
var initialState = fromJS({});
export default function webform() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case WEBFORM_GET_LOADED:
      {
        return state.setIn([action.webform_id, 'fields'], fromJS(action.data));
      }

    case WEBFORM_GET_INFO_LOADED:
      {
        return state.setIn([action.webform_id, 'info'], fromJS(action.data));
      }

    default:
      return state;
  }
}